import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.updateButtonState();
    this.inputTarget.addEventListener(
      "input",
      this.handleInput.bind(this)
    );
  }

  handleInput() {
    this.updateButtonState();
  }

  clear(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.updateButtonState();
  }

  updateButtonState() {
    const isEmpty =
      this.inputTarget.value === "" || this.inputTarget.value === "0";
    this.buttonTarget.toggleAttribute("data-active", isEmpty);

    if (isEmpty && this.inputTarget.value === "0") {
      // Clear the input if it's "0" to show placeholder
      this.inputTarget.value = "";
    }
  }
}
